export default __webpack_public_path__ + "static/UniversLTStd-BoldCn-ba0499df9ab6d6cfc6e6cbad76f57b32.ttf";